import { RadioGroup } from '../RadioGroup/RadioGroup.js';
import { RadioItemVariant } from '../RadioGroup/types.js';
import { ButtonGroupButtonType } from './types.js';
import { jsx } from 'react/jsx-runtime';

var ButtonGroup = function ButtonGroup(_ref) {
  var ariaLabel = _ref["aria-label"],
    initialValue = _ref.initialValue,
    items = _ref.items,
    onChange = _ref.onChange,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? ButtonGroupButtonType.GROUPED : _ref$type,
    value = _ref.value;
  return /*#__PURE__*/jsx(RadioGroup, {
    "aria-label": ariaLabel,
    initialValue: initialValue,
    onChange: onChange,
    variant: RadioItemVariant.BUTTON,
    items: items,
    buttonType: type,
    value: value
  });
};
ButtonGroup.displayName = "ButtonGroup";

export { ButtonGroup };
